import React, { useContext, useEffect, useState } from 'react'
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { Tooltip } from "@mui/material";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import { useNavigate } from 'react-router-dom';
import { PrasadOrderList } from '../../ApiServices/Prasad/PrasadApi';
import { LoaderContext } from '../../AuthContext/AuthContext';
import banner from '../../assets/images/new/orderPageBanner.png'
import prasadBooking from "../../assets/images/new/prasad booking.png";
const PrasadOrderPage = () => {
    const userIDD = JSON.parse(localStorage.getItem("userID"));
    const { setLoader, loader, activeCategory, setActiveCategory, isCartUpdate, setIsCartUpdate } = useContext(LoaderContext)
    const [orders, setOrders] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        GetPrasadOrderPageListData()
    }, []);

    const GetPrasadOrderPageListData = async () => {

        const data = localStorage.getItem("userID") || "";
        if (data === null || data === undefined || data === "") {
            return;
        }
        setLoader(true);
        try {
            const response = await PrasadOrderList({
                "START": 0,
                "END": 100,
                "WORD": "none"
            }, data);

            if (response?.ResponseCode == '0') {
                const responseData = response?.DATA || []
                setOrders(responseData);
                setLoader(false)
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    }

    const orderDetails = (myorders) => {
        navigate("/prasad-order-details", { state: myorders });
    };

    function formatToIndianCurrency(amount) {
        if (!amount) return "";

        const [integerPart, decimalPart] = amount.toString().split(".");

        // Format the integer part using Indian numbering system
        const formattedIntegerPart = integerPart.replace(
            // Match groups of 3 digits initially, then groups of 2 digits
            /(\d)(?=(\d\d)+\d$)/g,
            "$1,"
        );

        // Return the formatted value with the decimal part (if present)
        return decimalPart !== undefined
            ? `${formattedIntegerPart}.${decimalPart}`
            : formattedIntegerPart;
    }
    return (
        <>
            <section className="page-header">
                <div className="page-header__bg" style={{ backgroundImage: `url(${prasadBooking})` }}></div>
                <div className="container" >
                    <h2 className="page-header__title bw-split-in-left">Prasad Orders</h2>
                </div>
            </section>
            <div className="p-3 m-4 my-4">
                {orders?.length > 0 ? (
                    <div className="row gx-4 gy-4" style={{ justifyContent: 'left' }}>
                        {orders.map((order) => (
                            <div className="col-xl-4 col-lg-4 col-md-6" key={order.id}>
                                <div
                                    className="card border-0 shadow-lg p-2 h-100"
                                    onClick={() => orderDetails(order)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className="d-flex align-items-start">
                                        <img
                                            src={order?.PRODUCT_IMAGES || Batuk}
                                            alt={order.PUJA_NAME}
                                            className="rounded me-3"
                                            style={{ width: "100px", height: "100px", objectFit: "contain" }}
                                        />
                                        {/* Flex column wrapper */}
                                        <div className="d-flex flex-column justify-content-between w-100" style={{ minHeight: '100px' }}>
                                            <div style={{ height: '7em' }}>
                                                <h6
                                                    className="mb-1 text-truncate"
                                                    style={{
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                    }}
                                                    title={order.PRODUCT_NAMES}
                                                >
                                                    {order.PRODUCT_NAMES}
                                                </h6>
                                                <span className="fw-bold text-muted">#{order.BookingID}</span>
                                                <p className="mb-1">
                                                    <strong>Payment Status:</strong>{" "}
                                                    <span
                                                        style={{
                                                            color: order.PAYMENT_STATUS === "Pending" ? "red" : "green",
                                                            fontWeight: "600",
                                                        }}
                                                    >
                                                        {order.PAYMENT_STATUS}
                                                    </span>
                                                </p>
                                                <p className="mb-1 fw-bold">
                                                    <strong>Total Amount:</strong> ₹{" "}
                                                    {formatToIndianCurrency(order?.GrandTotal)}
                                                </p>
                                            </div>

                                            {/* Button always at bottom */}
                                            <div className="mt-3">
                                                <button
                                                    className="Normal-app-btn"
                                                    style={{
                                                        padding: "5px 10px",
                                                        fontSize: "12px",
                                                    }}
                                                >
                                                    View Details
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        ))}
                    </div>
                ) : loader === false ? (
                    <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
                        <img
                            src={Batuk}
                            alt="Empty Cart"
                            className="img-fluid mb-3"
                            style={{ maxWidth: "250px" }}
                        />
                        <h5 className="fw-bold">No orders found</h5>
                        <button
                            className="careox-btn"
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate("/services/puja-booking")}
                        >
                            Book now
                        </button>
                    </div>
                ) : (
                    ""
                )}
            </div>
        </>
    )
}

export default PrasadOrderPage
